/**
 * 보안 및 성능 제한 상수
 */

/** 최대 파일 크기: 10MB (이미지) */
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

/** 최대 동영상 파일 크기: 100MB */
export const MAX_VIDEO_FILE_SIZE = 100 * 1024 * 1024;

/** 업로드 타임아웃: 30초 (이미지 등) */
export const UPLOAD_TIMEOUT = 30000;

/** 대용량 파일(비디오 등) 업로드 타임아웃: 120초 */
export const UPLOAD_TIMEOUT_VIDEO = 120000;

/** 허용된 이미지 MIME 타입 (SVG 제외) */
export const ALLOWED_IMAGE_MIME_TYPES = new Set([
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/bmp",
]);

/** 차단된 파일 확장자 */
export const BLOCKED_EXTENSIONS = [".svg", ".svgz"];

/** 허용된 이미지 확장자 */
export const ALLOWED_IMAGE_EXTENSIONS = [
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".webp",
  ".bmp",
];

/** 허용된 동영상 MIME 타입 */
export const ALLOWED_VIDEO_MIME_TYPES = new Set([
  "video/mp4",
  "video/webm",
  "video/ogg",
  "video/quicktime", // .mov
]);

/** 허용된 동영상 확장자 */
export const ALLOWED_VIDEO_EXTENSIONS = [
  ".mp4",
  ".webm",
  ".ogg",
  ".mov",
];

/** 표 행 높이 리사이즈: 최소 행 높이(px) */
export const ROW_RESIZE_MIN_HEIGHT = 24;

/** 표 행 높이 리사이즈: 행 경계 hit-area 두께(px). columnResizing handleWidth(5)와 동일. */
export const ROW_RESIZE_HANDLE_WIDTH = 5;

/** 표 전체 스케일(코너 드래그): 우하단 코너 hit-area 한 변(px). */
export const TABLE_SCALE_CORNER_SIZE = 16;

/** 표 전체 스케일: 최소 열 너비(px). prosemirror-tables cellMinWidth(25) 근사. */
export const TABLE_SCALE_MIN_COL_WIDTH = 24;

/** 표 전체 스케일: 최대 배율(런어웨이 방지). */
export const TABLE_SCALE_MAX = 6;
